// axios基础封装
import axios from 'axios'
import { useLoginStore } from '@/store/modules/userlogin';
import { message } from 'ant-design-vue';

// 添加防抖控制变量
let successMessageTimer = null;
let errorMessageTimer = null;

const showSuccessMessage = (msg) => {
  if (successMessageTimer) {
    clearTimeout(successMessageTimer);
  }
  successMessageTimer = setTimeout(() => {
    message.success(msg);
    successMessageTimer = null;
  }, 800);
};

const showErrorMessage = (error) => {
  if (error && error.response && error.response.data && error.response.data.message) {
    message.error(error.response.data.message); // 只显示后台返回的具体错误信息
  } else if (error && error.message && !error.message.includes('status code')) {
    // 只显示非状态码相关的错误信息
    message.error(error.message);
  }
  if (errorMessageTimer) {
    clearTimeout(errorMessageTimer);
  }
  errorMessageTimer = setTimeout(() => {
    errorMessageTimer = null;
  }, 1000);
};

const httpInstance = axios.create({
 baseURL: 'http://zilizhou.vicp.net',
 // baseURL: 'https://177e0q09.goho.co',
  // baseURL: 'http://47.97.84.253:8080',
  timeout: 5000
})

// 拦截器
// 添加请求拦截器
httpInstance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  const userStore = useLoginStore()
  const token = userStore.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  console.log('Request', config);
  return config;
}, function (error) {
  console.error('Request Error', error)
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
httpInstance.interceptors.response.use(
  (response) => {
    console.log('Response:', response);
    if (response.config.method !== 'get') {
      if (response.data.code === 0 && response.data.message && response.data.message !== '操作成功') {
        showSuccessMessage(response.data.message);
      } else if (response.data.code !== 0 && response.data.message) {
        message.error(response.data.message); // 直接展示后台返回的错误信息
      }
    }
    if(response.data.message === '登录凭证失效'){
      const userStore = useLoginStore()
      userStore.removeUserInfo()
      // eslint-disable-next-line no-undef
      router.push('/')
    }
    return response;
  },
  (error) => {
    // 对响应错误做点什么
    showErrorMessage(error);
    console.error('Response Error:', error);
    if (error.response) {
      console.error('Server Response:', error.response.data);
      console.error('Status Code:', error.response.status);
    } else if (error.request) {
      console.error('No Response:', error.request);
    } else {
      console.error('Error Setting Request:', error.message);
    }
    const userStore = useLoginStore()
    if (error.response && error.response.status === 401) {
      userStore.removeUserInfo()
      // eslint-disable-next-line no-undef
      router.push('/')
    }
    return Promise.reject(error);
  }
);


export default httpInstance
